export const buildingSociety = {};
